import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Hotels from "@/pages/Hotels";
import Rooms from "@/pages/Rooms";
import Reservations from "@/pages/Reservations";
import CheckIn from "@/pages/CheckIn";
import Guests from "@/pages/Guests";
import Housekeeping from "@/pages/Housekeeping";
import Restaurant from "@/pages/Restaurant";
import Inventory from "@/pages/Inventory";
import Purchase from "@/pages/Purchase";
import Finance from "@/pages/Finance";
import HR from "@/pages/HR";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Payments from "@/pages/Payments";
import Banquet from "@/pages/Banquet";
import Maintenance from "@/pages/Maintenance";
import CRM from "@/pages/CRM";
import ChannelManager from "@/pages/ChannelManager";
import AuditLogs from "@/pages/AuditLogs";
import Payroll from "@/pages/Payroll";
import Profile from "@/pages/Profile";
import Notifications from "@/pages/Notifications";
import GuestApp from "@/pages/GuestApp";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Recipes from "@/pages/Recipes";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/guest" element={<GuestApp />} />
                        <Route path="/payment-success" element={<PaymentSuccess />} />

                        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                        <Route path="/hotels" element={<ProtectedRoute roles={["super_admin", "hotel_owner"]}><Hotels /></ProtectedRoute>} />
                        <Route path="/rooms" element={<ProtectedRoute><Rooms /></ProtectedRoute>} />
                        <Route path="/reservations" element={<ProtectedRoute><Reservations /></ProtectedRoute>} />
                        <Route path="/checkin" element={<ProtectedRoute><CheckIn /></ProtectedRoute>} />
                        <Route path="/guests" element={<ProtectedRoute><Guests /></ProtectedRoute>} />
                        <Route path="/housekeeping" element={<ProtectedRoute><Housekeeping /></ProtectedRoute>} />
                        <Route path="/restaurant" element={<ProtectedRoute><Restaurant /></ProtectedRoute>} />
                        <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
                        <Route path="/purchase" element={<ProtectedRoute><Purchase /></ProtectedRoute>} />
                        <Route path="/finance" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
                        <Route path="/hr" element={<ProtectedRoute><HR /></ProtectedRoute>} />
                        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
                        <Route path="/users" element={<ProtectedRoute roles={["super_admin", "hotel_owner", "general_manager", "hr"]}><Users /></ProtectedRoute>} />
                        <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
                        <Route path="/banquet" element={<ProtectedRoute><Banquet /></ProtectedRoute>} />
                        <Route path="/maintenance" element={<ProtectedRoute><Maintenance /></ProtectedRoute>} />
                        <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />
                        <Route path="/ota" element={<ProtectedRoute roles={["general_manager", "hotel_owner"]}><ChannelManager /></ProtectedRoute>} />
                        <Route path="/audit-logs" element={<ProtectedRoute roles={["super_admin", "hotel_owner", "general_manager"]}><AuditLogs /></ProtectedRoute>} />
                        <Route path="/payroll" element={<ProtectedRoute roles={["hr", "accountant", "general_manager", "hotel_owner"]}><Payroll /></ProtectedRoute>} />
                        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                        <Route path="/recipes" element={<ProtectedRoute roles={["restaurant_manager", "kitchen", "general_manager", "hotel_owner"]}><Recipes /></ProtectedRoute>} />
                    </Routes>
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
